import React, { useState, ChangeEvent, FormEvent } from "react";
import Button from "@mui/joy/Button";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import { useNavigate } from "react-router-dom";
import { auth } from "../FirebaseConfig";
import { sendPasswordResetEmail } from "firebase/auth";
import { toast } from "react-toastify";
import Input from "@mui/joy/Input";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SendIcon from "@mui/icons-material/Send";

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      toast.success("Password reset email sent successfully");
      setTimeout(() => navigate("/signin"), 5000);
    } catch (error) {
      console.error(error);
      toast.error("Failed to send password reset email");
    }
  };

  const handleBackToSignIn = () => {
    navigate("/signin");
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="90vh"
    >
      <form onSubmit={handleSubmit}>
        <Typography level="h2" sx={{ marginTop: "2%", marginBottom: "1%" }}>
          Reset your password
        </Typography>
        <Typography
          level="title-md"
          color="neutral"
          sx={{ marginTop: "1%", marginBottom: "5%" }}
        >
          Enter the email address you used to register, and we will send you a
          link to reset your password.
        </Typography>
        <Input
          type="email"
          value={email}
          variant="soft"
          onChange={handleEmailChange}
          placeholder="Enter your email address"
          sx={{
            marginBottom: "5%",
            height: "6vh",
            width: {
              xs: "100%",
              sm: "100%",
              lg: "50vw",
            },
          }}
        />
        <Box display="flex" justifyContent="space-between">
          <Button
            type="button"
            variant="plain"
            startDecorator=<ArrowBackIosIcon />
            size="lg"
            onClick={handleBackToSignIn}
          >
            Back to Sign In
          </Button>
          <Button
            type="submit"
            variant="plain"
            size="lg"
            endDecorator=<SendIcon />
          >
            Send instructions
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default ResetPassword;
